import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Sidebar from "./components/Sidebar";
import SliderHistory from "./components/SliderHistory/SliderHistory";
import Cars from "./pages/Brands";
import Home from "./pages/Home";
import Car from "./pages/Car/Car";
import Brands from "./Data/Brands";
import AllCar from "./Data";
import classNames from "classnames/bind";
import styles from "./App.module.scss";
import Footer from "./components/Footer";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleChevronUp } from "@fortawesome/free-solid-svg-icons";
import { useRef } from "react";
const cx = classNames.bind(styles);
function App() {
    console.log(SliderHistory);
    console.log("APP");
    console.log(AllCar);
    const bodyRef = useRef();
    const handleTop = () => {
        bodyRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
    };
    const mediaQuery = window.matchMedia("(min-width: 768px)").matches;
    if (!mediaQuery) {
        window.addEventListener("scroll", () => {
            const top = document.getElementsByClassName(cx("top"));
            if (window.scrollY > 70) {
                top[0].classList.remove(cx("hide"));
            } else {
                top[0].classList.add(cx("hide"));
            }
        });
    }

    return (
        <>
            <Router>
                <div className="App">
                    <Header />

                    {!mediaQuery && (
                        <div className={cx("top", "hide")} onClick={handleTop}>
                            <FontAwesomeIcon icon={faCircleChevronUp} />
                        </div>
                    )}

                    <Helmet>
                        <title>Vũ Trụ Siêu Xe - Supercar Universe</title>
                        <meta
                            name="description"
                            content="Vũ trụ siêu xe - Cập nhật thông tin siêu xe các hãng nổi tiếng trên thế giới. Giá xe, hình ảnh và thông số chi tiết xe các hãng lớn Bugatti, Lamborghini, Pagani, Ferrari, Mercedes Benz,... Cùng khám phá nhé!"
                        />
                        <meta
                            name="keywords"
                            content="Vũ trụ siêu xe, supercar universe, hãng siêu xe nổi tiếng, siêu xe"
                        />
                    </Helmet>
                    <div ref={bodyRef} className={cx("body")}>
                        <Sidebar />
                        <Routes>
                            <Route exact path="/" element={<Home />}></Route>
                            <Route
                                exact
                                path="/brands"
                                element={<Cars />}
                            ></Route>
                            {Brands.map((brand, index) => {
                                return (
                                    <Route
                                        exact
                                        key={index}
                                        path={brand.path}
                                        element={<Cars data={brand} />}
                                    ></Route>
                                );
                            })}
                            {AllCar.map((car, index) => {
                                return (
                                    <Route
                                        exact
                                        key={index}
                                        path={car.link}
                                        element={<Car data={car} />}
                                    ></Route>
                                );
                            })}
                        </Routes>
                    </div>
                    <Footer />
                </div>
            </Router>
        </>
    );
}

export default App;
